module.exports = __webpack_public_path__ + "c9969e7e9380880a1f11a7fa1f3e1f24.svg";